// extracted by mini-css-extract-plugin
export var circle = "_b4-1";
export var exitConfirmationModal = "_b4-5";
export var iframe = "_b4-0";
export var offline = "_b4-3";
export var online = "_b4-2";
export var workstationSelectError = "_b4-4";